/**
 * U15 F1: texto da aula de ajuda em blocos para o painel. O texto vem do banco (a `descricao` da aula) e é sempre mostrado
 * como TEXTO (nunca como HTML ou markdown): aqui só se separa a estrutura. O formato do curso "Ajuda das telas" é uma lista
 * de blocos separados por linha em branco, cada um com um subtítulo curto na primeira linha ("Para que serve", "Como fazer",
 * "Dica", "Se der errado") e, no "Como fazer", passos numerados ("1. ..."). Texto de outro formato (aula editada à mão) vira
 * parágrafos, sem perda.
 */
export interface BlocoAjuda {
  /** Subtítulo do bloco (primeira linha curta, sem pontuação final), ou null. */
  titulo: string | null;
  paragrafos: string[];
  /** Passos numerados, sem o "1. " do início. */
  passos: string[];
}

const PASSO = /^\s*\d{1,2}[.)]\s+(.+)$/;
/** Uma linha curta e sem ponto final, seguida de mais linhas, é o subtítulo do bloco. */
const ehSubtitulo = (linha: string) => linha.length <= 40 && !/[.!?:;,]$/.test(linha) && !PASSO.test(linha);

export function blocosDoTexto(texto: string | null | undefined): BlocoAjuda[] {
  if (!texto?.trim()) return [];
  return texto
    .replace(/\r\n?/g, '\n')
    .split(/\n{2,}/)
    .map((b) => b.split('\n').map((l) => l.trim()).filter(Boolean))
    .filter((linhas) => linhas.length > 0)
    .map((linhas) => {
      const titulo = linhas.length > 1 && ehSubtitulo(linhas[0]!) ? linhas.shift()! : null;
      const passos: string[] = [];
      const paragrafos: string[] = [];
      for (const l of linhas) {
        const m = PASSO.exec(l);
        if (m) passos.push(m[1]!.trim());
        else paragrafos.push(l);
      }
      return { titulo, paragrafos, passos };
    });
}
